import React from 'react';
import styled from 'styled-components';
import { keyObjects } from '../../Content';


const ColorKey = () => (
  <SColorKey className="key">
    {keyObjects.map(({ title, range, color }) => (
      <div key={Math.random()}>
        <ColorBlock color={color} />
        <div className="copy">
          <strong>{title}</strong>
          <span>{range}</span>
        </div>
      </div>
    ))}
  </SColorKey>
);

export default ColorKey;

const ColorBlock = styled.span`
  display: block;
  background-color: ${({ color }) => color};
  width: 15px;
  height: 15px;
`;

const SColorKey = styled.div`
  display: flex;
  justify-content: center;
  margin-right: -47px;
  padding-bottom: 30px;

  > div {
    position: relative;
    padding: 0 40px 0 7px;

    ${ColorBlock} {
      position: absolute;
      top: 0;
      right: 100%;
    }
  }

  .copy {
    text-align: left;
    font-size: 14px;

    strong {
      display: block;
      margin-bottom: 5px;
    }

    span {
      font-size: 0.8em;
    }
  }
`;
